import { listSaveGraphApi, platformModuleslistApi, deleteGraphApi} from '@/api/graph'
import { mapGetters, mapActions } from 'vuex'

export const GraphMixins = {
  data () {
    return {
      platform_modules:[],
      lineGraphData:[],
      SelectedLineGraphId:null,
      SelectedBarGraphId:null,
      SelectedColumnGraphId: null,
      SelectedRadarGraphId: null,
      SelectedPieGraphId:null,
      listGraph:[
        {
          graphName:'Line chart',
          graphType:'line',
          isGraphOpen:false,
          data:[]
        },
        {
          graphName:'Bar Chart',
          graphType:'bar',
          isGraphOpen:false,
          data:[]

        },
        {
          graphName:'Horizontal Bar chart',
          graphType:'column',
          isGraphOpen:false,
          data:[]

        },
        {
          graphName:'Pie chart',
          graphType:'pie',
          isGraphOpen:false,
          data:[]

        }
      ]
    }
  },
  computed:{
    ...mapGetters(['get_platform_modules_item_data'])

  },
  methods:{
    ...mapActions(['SET_PLATFORM_MODULES_GRAPH_ACTION', 'DELETE_GRAPH_ACTION']),
    async getIndividualSaveApi (type, index) {
      const payload = {
        search:type
      }
      
      
      if (!this.platform_modules[index].isGraphOpen) {
        const {data} = await listSaveGraphApi(localStorage.getItem('customer_id'), payload)
        this.platform_modules[index].data = [...data.data.graphs]
        // 
        this.platform_modules[index].isGraphOpen = true
      }
    },
    async fetchPlatformModule () {
      this.$vs.loading({
        text:'Fetching graphs'
      })
      try {
        const response = await platformModuleslistApi()
        this.platform_modules = response.data.data.modules_list.map(ele => {
          return {
            ...ele,
            isGraphOpen:false,
            data:[]
          }
        })

        this.SET_PLATFORM_MODULES_GRAPH_ACTION(this.platform_modules)

      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }

    },
    
    async getGenratedSaveData (id, type) {

      console.log('hit here')
      switch (type) {
      case 'line':
        this.SelectedLineGraphId = id
        this.SelectedBarGraphId = null
        this.SelectedColumnGraphId = null
        this.SelectedRadarGraphId = null
        this.SelectedPieGraphId = null
        break
          
      case 'bar':
        this.SelectedLineGraphId = null
        this.SelectedBarGraphId = id
        this.SelectedColumnGraphId = null
        this.SelectedRadarGraphId = null
        this.SelectedPieGraphId = null
        break

      case 'column':
        this.SelectedLineGraphId = null
        this.SelectedBarGraphId = null
        this.SelectedColumnGraphId = id
        this.SelectedRadarGraphId = null
        this.SelectedPieGraphId = null
        break

      case 'radar':
        this.SelectedLineGraphId = null
        this.SelectedBarGraphId = null
        this.SelectedColumnGraphId = null
        this.SelectedRadarGraphId = id
        this.SelectedPieGraphId = null
        break

      case 'pie':
        this.SelectedLineGraphId = null
        this.SelectedBarGraphId = null
        this.SelectedColumnGraphId = null
        this.SelectedRadarGraphId = null
        this.SelectedPieGraphId = id
        break
      }
      
      /* const data = await getGeneratedSavedApi(localStorage.getItem('customer_id'), id)
      
       */
    },
    async deleteGraph (graphIndex, platformIndex, graphId) {
      // 
      const customer_id = localStorage.getItem('customer_id')
      const data = await deleteGraphApi(customer_id, graphId)
      const payload = {
        platformIndex,
        graphIndex
      }
      

      this.showSuccessMessage('Delete', 'Deleted Successfully', 'success')
      

      this.DELETE_GRAPH_ACTION(payload)
      
      
    }
  }
}